<template>
	<div id="app">
		<dashboard v-if="authenticated" />
		<auth-form v-else />
		<message /> 
	</div>
</template>

<script>
import Dashboard from './components/Dashboard.vue'
import AuthForm from './components/AuthForm.vue'
import Message from './components/Message' 



export default {
	name: 'app',
	components: {
		Dashboard,
		AuthForm,
		Message
	},

	computed: {
		authenticated() {
			return this.$store.state.auth
		}
	},


	watch: {
		authenticated(value) {
			//console.log('Watch authenticated: ', value)

			if (value) {
				//console.log('Start autorefresh')
				this.$store.dispatch('startAutoRefresh')
			} else {
				//console.log('Stop autorefresh')
				this.$store.dispatch('stopAutoRefresh')
			}
		}
	}
}
</script>

<style lang="scss">
/* @import "../node_modules/bootstrap/dist/css/bootstrap.min.css"; */
@import "../node_modules/font-awesome/css/font-awesome.min.css";

HTML, BODY {
	
	padding: 0;
	margin: 0;
	height: 100%;
}

BODY {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* background-color: #2c3e50; */
	/* background-color: #0e1012; */
	background-color: #2b2b2b;
	color: #FFF;
	
	font-size: 14px;
	
}

#app {
	max-width: 700px;
	margin-left: auto;
	margin-right: auto;
	

	position: relative;

	box-sizing: border-box;
	height: 100%;
}

@media (max-width: 700px)  {
	#app {
		margin-left: 10px;
		margin-right: 10px;
	}
	
}
</style>
